import CurrencyFormatter from '../../components/Grid/CurrencyFormatter';
import { DateFormatter } from '../../components/Grid/formatters/DateFormater';
import CurrencySummary from '../../components/Grid/CurrencySummary';
import NumberFormatter from '../../components/Grid/NumberFormatter';
import Summary from '../../components/Grid/Summary';

export default [
	{
		key: 'reason',
		name: 'Motivo',
		type: 'text',
		resizable: true,
		filterable: true,
		sortable: true,
		width: 150,
	},
	{
		key: 'representativeName',
		name: 'Representante',
		type: 'text',
		resizable: true,
		filterable: true,
		sortable: true,
	},
	{
		key: 'salesOrder',
		name: 'Pedido',
		type: 'number',
		resizable: true,
		filterable: true,
		sortable: true,
		width: 70,
	},
	{
		key: 'deliveryDate',
		name: 'Data',
		type: 'date',
		resizable: true,
		filterable: true,
		sortable: true,
		width: 70,
		formatter: DateFormatter,
	},
	{
		key: 'cancellationDate',
		name: 'Dt. Cancelamento',
		type: 'date',
		resizable: true,
		filterable: true,
		sortable: true,
		formatter: DateFormatter,
		width: 130,
	},
	{
		key: 'blockingDate',
		name: 'Dt. Bloqueio',
		type: 'text',
		resizable: true,
		filterable: true,
		sortable: true,
		formatter: DateFormatter,
		width: 100,
	},
	{
		key: 'daysBlocked',
		name: 'Dias Bloq.',
		type: 'number',
		resizable: true,
		filterable: true,
		sortable: true,
		width: 80,
	},
	{
		key: 'customerName',
		name: 'Cliente',
		type: 'text',
		resizable: true,
		filterable: true,
		sortable: true,
	},
	{
		key: 'cityName',
		name: 'Cidade',
		type: 'text',
		resizable: true,
		filterable: true,
		sortable: true,
		width: 80,
	},
	{
		key: 'stateCode',
		name: 'UF',
		type: 'text',
		resizable: true,
		filterable: true,
		sortable: true,
		width: 40,
	},
	{
		key: 'canceled',
		name: 'Qtde',
		type: 'text',
		resizable: true,
		filterable: true,
		sortable: true,
		width: 100,
		formatter: NumberFormatter,
		formatter_index: 1,
		summary: Summary,
	},
	{
		key: 'canceledValue',
		name: 'Valor',
		type: 'text',
		resizable: true,
		filterable: true,
		sortable: true,
		width: 100,
		formatter: CurrencyFormatter,
		summary: CurrencySummary,
	},
];
